<template>
    <div class="moon-aside">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name:'MoonAside',
        props:{

        }
    };
</script>

<style lang="scss" scoped>
</style>